import React, { useReducer, useEffect, useContext } from "react";
import {
  Col,
  Row,
  Accordion,
  Image,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import { GiMeal } from "react-icons/gi";
import { FaCartPlus, FaSchool, FaShoppingCart, FaUser } from "react-icons/fa";
import { BiSolidUserDetail } from "react-icons/bi";
import { BsBriefcase } from "react-icons/bs";
import { LuPartyPopper, LuUser } from "react-icons/lu";
import { GiPartyPopper } from "react-icons/gi";
import { IoCardOutline } from "react-icons/io5";
import { MdContactMail } from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";
import axiosInstance from "../../../config/axios";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { AuthContext } from "../../../contexts/AuthContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  detailsInitialState,
  detailsReducer,
} from "../../../reducers/module/detailsReducer";
function QuickTabs({ view, setView }) {
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    detailsInitialState
  );
  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const { userAuthState, role } = useContext(AuthContext);

  const loadItem = async () => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });
    try {
      const res = await axiosInstance.get(`general/dashboard-stats`);
      detailsDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  useEffect(() => {
    loadItem();
  }, []);

  return (
    <>
      {detailsState.isFetching === true && <FullPageOverlay />}
      {detailsState.data && (
        <>
          <>
            <div className="p-0">
              <Row className="p-2">
                {detailsState?.data?.subscriptions &&
                  role?.toLowerCase() === "admin" && (
                    <Col
                      xl={4}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="flex-1  mb-2"
                    >
                      <div className="dashboard-box bg-linear-1 d-flex flex-column justify-content-between align-items-center text-center h-100 w-100 p-4 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                        {/* Header Row: Icon + Title */}
                        <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
                          <div className="text-white">
                            <GiMeal size={46} className="opacity-75" />
                          </div>
                          <h5 className="dashboard-box-heading text-white fw-semibold mb-0">
                            Meal Subscriptions
                          </h5>
                        </div>

                        {/* Total Count */}
                        <div
                          title="Click to view all subscriptions"
                          className="dashboard-box-text mb-1 cursor-pointer"
                          onClick={() => handleNavigate("/subscriptions")}
                        >
                          <strong className="display-5 fw-bold text-white d-block lh-1">
                            {detailsState?.data?.subscriptions?.total}
                          </strong>
                          <small className="text-white-50">
                            Total Subscriptions
                          </small>
                        </div>

                        {/* Divider */}
                        <hr className="border-white border-opacity-25 w-75 my-1" />

                        {/* Breakdown Info Boxes */}
                        <div className="d-flex justify-content-center flex-wrap gap-3 w-100">
                          {/* Active */}
                          <div
                            title="Click to view active subscriptions"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/subscriptions?status=Active")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.subscriptions?.active ?? 0}
                            </span>
                            <small className="text-white-50">Active</small>
                          </div>

                          <div
                            title="Click to view paused subscriptions"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/subscriptions?status=Paused")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.subscriptions?.paused ?? 0}
                            </span>
                            <small className="text-white-50">Paused</small>
                          </div>

                          {/* Cancelled */}

                          <div
                            title="Click to view cancelled subscriptions"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/subscriptions?status=Cancelled")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.subscriptions?.cancelled ??
                                0}
                            </span>
                            <small className="text-white-50">Cancelled</small>
                          </div>

                          <div
                            title="Click to view expired subscriptions"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/subscriptions?status=Cancelled")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.subscriptions?.expired ?? 0}
                            </span>
                            <small className="text-white-50">Expired</small>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                {detailsState?.data?.orders &&
                  role?.toLowerCase() === "admin" && (
                    <Col
                      xl={4}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="flex-1  mb-2"
                    >
                      <div className="dashboard-box bg-linear-4 d-flex flex-column justify-content-between align-items-center text-center h-100 w-100 p-4 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                        {/* Header Row: Icon + Title */}
                        <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
                          <div className="text-white">
                            <BsBoxSeam size={35} className="opacity-75" />
                          </div>
                          <h5 className="dashboard-box-heading text-white fw-semibold mb-0">
                            Product Orders
                          </h5>
                        </div>

                        {/* Total Count */}
                        <div
                          title="Click to view all orders"
                          className="dashboard-box-text mb-1 cursor-pointer"
                          onClick={() => handleNavigate("/orders")}
                        >
                          <strong className="display-5 fw-bold text-white d-block lh-1">
                            {detailsState?.data?.orders?.total}
                          </strong>
                          <small className="text-white-50">Total Orders</small>
                        </div>

                        {/* Divider */}
                        <hr className="border-white border-opacity-25 w-75 my-1" />

                        {/* Breakdown Info Boxes */}
                        <div className="d-flex justify-content-center flex-wrap gap-3 w-100">
                          {/* Active */}
                          <div
                            title="Click to view processing orders"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/orders?orderStatus=0")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.orders?.pending ?? 0}
                            </span>
                            <small className="text-white-50">Processing</small>
                          </div>

                          <div
                            title="Click to view delivered orders"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/orders?orderStatus=1")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.orders?.delivered ?? 0}
                            </span>
                            <small className="text-white-50">Delivered</small>
                          </div>

                          {/* Cancelled */}

                          <div
                            title="Click to view cancelled orders"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/orders?orderStatus=2")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.orders?.cancelled ?? 0}
                            </span>
                            <small className="text-white-50">Cancelled</small>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}

                {detailsState?.data?.customers &&
                  role?.toLowerCase() === "admin" && (
                    <Col
                      xl={4}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="flex-1  mb-2"
                    >
                      <div className="dashboard-box bg-linear-3 d-flex flex-column justify-content-between align-items-center text-center h-100 w-100 p-4 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                        {/* Header Row: Icon + Title */}
                        <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
                          <div className="text-white">
                            <FaUser size={35} className="opacity-75" />
                          </div>
                          <h5 className="dashboard-box-heading text-white fw-semibold mb-0">
                            Customers
                          </h5>
                        </div>

                        {/* Total Count */}
                        <div
                          title="Click to view all customers"
                          className="dashboard-box-text mb-1 cursor-pointer"
                          onClick={() => handleNavigate("/customers")}
                        >
                          <strong className="display-5 fw-bold text-white d-block lh-1">
                            {detailsState?.data?.customers?.total}
                          </strong>
                          <small className="text-white-50">
                            Total Customers
                          </small>
                        </div>

                        {/* Divider */}
                        <hr className="border-white border-opacity-25 w-75 my-1" />

                        {/* Breakdown Info Boxes */}
                        <div className="d-flex justify-content-center flex-wrap gap-3 w-100">
                          {/* Active */}
                          <div
                            title="Click to view customers having orders"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/customers?has=orders")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.customers?.havingOrders ?? 0}
                            </span>
                            <small className="text-white-50">
                              Having Orders
                            </small>
                          </div>

                          <div
                            title="Click to view customers having subscription"
                            className=" bg-opacity-10 rounded-3 px-3 py-2 text-center min-w-[90px] cursor-pointer"
                            onClick={() =>
                              handleNavigate("/customers?has=subscriptions")
                            }
                          >
                            <span className="d-block fw-bold text-white fs-5">
                              {detailsState?.data?.orders
                                ?.havingSubscriptions ?? 0}
                            </span>
                            <small className="text-white-50">
                              Having Subscriptions
                            </small>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                {/* <Col
                  xl={4}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="flex-1 cursor-pointer mb-2"
                  onClick={() => handleNavigate("/carts")}
                >
                  <div className="dashboard-box bg-linear-2 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
              
                    <div className="dashboard-box-icon text-white mb-3">
                      <FaShoppingCart size={48} className="opacity-75" />
                    </div>

                   
                    <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                      Total Carts
                    </h5>

                 
                    <div className="dashboard-box-text">
                      <strong className="display-5 fw-bold text-white d-block lh-1">
                        2
                      </strong>
                    </div>
                  </div>
                </Col> */}
                {detailsState?.data?.payments >= 0 &&
                  role?.toLowerCase() === "admin" && (
                    <Col
                      xl={4}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      title="Click to view all payments"
                      className="flex-1 cursor-pointer mb-2"
                      onClick={() => handleNavigate("/payments")}
                    >
                      <div className="dashboard-box bg-linear-5 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                        {/* Icon */}
                        <div className="dashboard-box-icon text-white mb-3">
                          <IoCardOutline size={48} className="opacity-75" />
                        </div>

                        {/* Heading */}
                        <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                          Total Payments
                        </h5>

                        {/* Count */}
                        <div className="dashboard-box-text">
                          <strong className="display-5 fw-bold text-white d-block lh-1">
                            {detailsState?.data?.payments}
                          </strong>
                        </div>
                      </div>
                    </Col>
                  )}
                {detailsState?.data?.contactUsSubmissionsCount >= 0 && (
                  <Col
                    xl={4}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    title="Click to view all contact us submissions"
                    className="flex-1 cursor-pointer mb-2"
                    onClick={() => handleNavigate("/contact-us")}
                  >
                    <div className="dashboard-box bg-linear-10 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                      {/* Icon */}
                      <div className="dashboard-box-icon text-white mb-3">
                        <MdContactMail size={48} className="opacity-75" />
                      </div>

                      {/* Heading */}
                      <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                        Contact Us Submissions
                      </h5>

                      {/* Count */}
                      <div className="dashboard-box-text">
                        <strong className="display-5 fw-bold text-white d-block lh-1">
                          {detailsState?.data?.contactUsSubmissionsCount}
                        </strong>
                      </div>
                    </div>
                  </Col>
                )}
                {detailsState?.data?.partyRequestsCount >= 0 && (
                  <Col
                    xl={4}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    title="Click to view all party requests"
                    className="flex-1 cursor-pointer mb-2"
                    onClick={() => handleNavigate("/party-requests")}
                  >
                    <div className="dashboard-box bg-linear-9 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                      {/* Icon */}
                      <div className="dashboard-box-icon text-white mb-3">
                        <GiPartyPopper size={48} className="opacity-75" />
                      </div>

                      {/* Heading */}
                      <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                        Party Requests
                      </h5>

                      {/* Count */}
                      <div className="dashboard-box-text">
                        <strong className="display-5 fw-bold text-white d-block lh-1">
                          {detailsState?.data?.partyRequestsCount}
                        </strong>
                      </div>
                    </div>
                  </Col>
                )}
                {detailsState?.data?.schoolNurseryRequestsCount >= 0 && (
                  <Col
                    xl={4}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    title="Click to view all school/nursery requests"
                    className="flex-1 cursor-pointer mb-2"
                    onClick={() => handleNavigate("/school-nursery-requests")}
                  >
                    <div className="dashboard-box bg-linear-8 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                      {/* Icon */}
                      <div className="dashboard-box-icon text-white mb-3">
                        <FaSchool size={48} className="opacity-75" />
                      </div>

                      {/* Heading */}
                      <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                        School/Nursery Requests
                      </h5>

                      {/* Count */}
                      <div className="dashboard-box-text">
                        <strong className="display-5 fw-bold text-white d-block lh-1">
                          {detailsState?.data?.schoolNurseryRequestsCount}
                        </strong>
                      </div>
                    </div>
                  </Col>
                )}
                {detailsState?.data?.testimonialsCount >= 0 && (
                  <Col
                    xl={4}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    title="Click to view all testimonials"
                    className="flex-1 cursor-pointer mb-2"
                    onClick={() => handleNavigate("/orders")}
                  >
                    <div className="dashboard-box bg-linear-7 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                      {/* Icon */}
                      <div className="dashboard-box-icon text-white mb-3">
                        <BiSolidUserDetail size={48} className="opacity-75" />
                      </div>

                      {/* Heading */}
                      <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                        Testimonial Submissions
                      </h5>

                      {/* Count */}
                      <div className="dashboard-box-text">
                        <strong className="display-5 fw-bold text-white d-block lh-1">
                          {detailsState?.data?.testimonialsCount}
                        </strong>
                      </div>
                    </div>
                  </Col>
                )}
                {detailsState?.data?.jobApplicationsCount >= 0 && (
                  <Col
                    xl={4}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    title="Click to view all job applications"
                    className="flex-1 cursor-pointer mb-2"
                    onClick={() => handleNavigate("/job-applications")}
                  >
                    <div className="dashboard-box bg-linear-6 d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 p-3 rounded-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                      {/* Icon */}
                      <div className="dashboard-box-icon text-white mb-3">
                        <BsBriefcase size={48} className="opacity-75" />
                      </div>

                      {/* Heading */}
                      <h5 className="dashboard-box-heading text-white font-italic  mb-2">
                        Job Applications
                      </h5>

                      {/* Count */}
                      <div className="dashboard-box-text">
                        <strong className="display-5 fw-bold text-white d-block lh-1">
                          {detailsState?.data?.jobApplicationsCount}
                        </strong>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </>
        </>
      )}
    </>
  );
}

export default QuickTabs;
